@if (loading()) {
<div class="spinner-overlay">
    <mat-spinner></mat-spinner>
</div>
} @else {
<mat-card style="margin: 10px;">
    <mat-card-header>
        <mat-card-title>Preference summary</mat-card-title>
        <mat-card-subtitle>{{ totalAttendees }} attendee(s) registered for {{ event.shortName }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        @if (groupTallies.length === 0) {
        <p>No options are defined for this event.</p>
        }
        @for (gt of groupTallies; track gt.group.id) {
            <div class="pref-group">
                <h3 class="pref-group-label">{{ gt.group.label }}</h3>
                @if (gt.group.hint) {
                <p class="pref-hint">{{ gt.group.hint }}</p>
                }
                <div class="pref-row pref-row-header">
                    <span class="pref-label">Option</span>
                    <span class="pref-count">Attendees</span>
                    <span class="pref-pct">%</span>
                </div>
                <hr/>
                @for (t of gt.items; track t.item.id) {
                <div class="pref-row">
                    <span class="pref-label" [matTooltip]="t.item.hint ?? ''">{{ t.item.label }}</span>
                    <span class="pref-count">{{ t.count }}</span>
                    <span class="pref-pct">{{ pct(t.count) }}%</span>
                </div>
                }
                <div class="pref-row pref-row-total">
                    <span class="pref-label">Total selections ({{ gt.group.exclusive ? 'exclusive choice' : 'multiple
                        allowed' }})</span>
                    <span class="pref-count">{{ gt.totalSelections }}</span>
                    <span class="pref-pct"></span>
                </div>
            </div>
        }
    </mat-card-content>
</mat-card>
}